import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import eye from "../../assets/view-eye.svg";
import "./settings.css";
import { useDispatch } from "react-redux";
import { settingsAccountDispatch } from "../../redux/actions/settingAction";
import PdfView from "../../components/modals/PdfView";

const SettingsAccount = () => {
  const dispatch = useDispatch();
  const [accountData, setAccountData] = useState("");
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfFileUrl, setPdfFileUrl] = useState(null);
  const [filename, setFileName] = useState(null);

  useEffect(() => {
    dispatch(settingsAccountDispatch(onAccountSuccess, onAccountError));
  }, []);

  const onAccountSuccess = (data) => {
    console.log(data);
    setAccountData(data.data.data);
    console.log(data.data.data);
  };

  const onAccountError = (err) => {
    console.log(err);
  };

  const data = [
    {
      heading: "Email Address",
      title: accountData?.email,
    },
    {
      heading: "District",
      title: accountData?.district?.name,
    },
    {
      heading: "Mobile Number",
      title: accountData?.mobile,
    },
    {
      heading: "State",
      title: accountData?.state?.name,
    },
    {
      heading: "Alternate Mobile Number",
      title: accountData?.alternate_mobile,
    },

    {
      heading: "City",
      title: accountData?.city?.name,
    },
    {
      heading: "Address",
      title: `${accountData?.address?.address_one}, ${accountData?.address?.address_two}, ${accountData?.address?.address_three}`,
    },
    {
      heading: "Pincode",
      title: accountData?.pincode,
    },
    {
      heading: "Landmark",
      title: accountData?.address?.landmark,
    },
  ];
  return (
    <>
      <div className="scrolling p-4">
        <div className="">
          <span className="fs_20 fw_400">Account</span>
        </div>
        <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
          <label className="basic-title mx-2 mb-1">Basic Details</label>
        </div>
        <div className="row mt-3">
          <div className="col-xl-6">
            <div className=" px-3">
              <div className="my-2">
                <div className="upload-image-label-container d-flex justify-content-between">
                  <label className="my-1 Neutral_Color">
                    Manufacturer Logo
                  </label>
                </div>
                <div className="view-logo-upload-container">
                  <img
                    className="view-image"
                    style={{ borderRadius: "7px" }}
                    src={accountData?.logo}
                  />
                </div>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">
                  Manufacturer Name
                </label>
                <p className="fs_14">{accountData?.name}</p>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">Drug License 1 </label>
                <p className="fs_14">{accountData?.drug_licence_1}</p>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">Drug License 2 </label>
                <p className="fs_14">{accountData?.drug_licence_2}</p>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className=" px-3">
              <div className="my-2">
                <label className=" Neutral_Color fs_14">CIN. No</label>
                <p className="fs_14">{accountData?.cin_number}</p>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">FSSAI Number</label>
                <p className="fs_14">{accountData?.fssai_number}</p>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">GSTIN Number</label>
                <p className="fs_14">{accountData?.gstin_number}</p>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">PAN Number</label>
                <p className="fs_14">{accountData?.pan_number}</p>
              </div>
              <div className="my-2">
                <label className=" Neutral_Color fs_14">Order Validity</label>
                <p className="fs_14">{accountData?.setting?.order_validity}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
          <label className="basic-title mx-2 mb-1">Contact Details</label>
        </div>
        <div>
          <div className="row mt-3">
            <div className="pt-3 ps-4 row">
              {data.map((item, index) => (
                <div
                  key={index}
                  className="mb-2 col-lg-6 customers-heading-container"
                >
                  <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                    {item.heading}
                  </h5>
                  {item.heading === "Email Address" ? (
                    <p
                      className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice`}
                      title={item.title}
                    >
                      {item.title}
                    </p>
                  ) : item.heading ? (
                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {item.title}
                    </p>
                  ) : (
                    <p
                      className={`fs_15 fn_Nunito fw_500 color_262c3d  text-nowrap`}
                    >
                      {item.title}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
          <label className="basic-title mx-2 mb-1">Documents</label>
        </div>
        <div className="row mt-3">
          <div className=" col-xl-6">
            <div className=" px-3">
              <div className="my-2">
                <div className="upload-image-label-container d-flex justify-content-between">
                  <label className="my-1 Neutral_Color">GST Certificate</label>
                </div>
                {accountData?.gst_certificate !== "" &&
                  accountData?.gst_certificate !== null && (
                    <div
                      className={` h-100`}
                      style={{
                        height: "25rem",
                        // width: "15rem",
                        // border: "1px solid black",
                        overflowY: "scroll",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      <div className="manufacturer-doc-upload-container">
                      <iframe
                          src={`${accountData?.gst_certificate}#toolbar=0`}
                          className="pdf-view-doc"
                        />
                      </div>
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            <button
                              className="fs_16 fw_600"
                              style={{
                                // position: "absolute",
                                // zIndex: "55",
                                // top: "80px",
                                // left: "180px",
                                backgroundColor: "transparent",
                                color: "#E7E5FF",
                                border: "none",
                              }}
                              onClick={() => {
                                setOpenPdf(true);
                                setPdfFileUrl(accountData?.gst_certificate);
                                setFileName("GST Certificate");
                              }}
                            >
                              VIEW
                            </button>
                          </div>
                        </div>
                      </div>                     
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className=" col-xl-6">
            <div className=" px-3">
              <div className="my-2">
                <div className="upload-image-label-container d-flex justify-content-between">
                  <label className="my-1 Neutral_Color">
                    Drug Manufacturing License
                  </label>
                </div>
                {accountData?.drug_manufacturing_license !== "" &&
                  accountData?.drug_manufacturing_license !== null && (
                    <div
                      className={` h-100`}
                      style={{
                        height: "25rem",
                        // width: "15rem",
                        // border: "1px solid black",
                        overflowY: "scroll",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      <div className="manufacturer-doc-upload-container">
                        <iframe
                          src={`${accountData?.drug_manufacturing_license}#toolbar=0`}
                          className="pdf-view-doc"
                        />
                      </div>

                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            <button
                              className="fs_16 fw_600"
                              style={{
                                // position: "absolute",
                                // zIndex: "55",
                                // top: "80px",
                                // left: "180px",
                                backgroundColor: "transparent",
                                color: "#E7E5FF",
                                border: "none",
                              }}
                              onClick={() => {
                                setOpenPdf(true);
                                setPdfFileUrl(
                                  accountData?.drug_manufacturing_license
                                );
                                setFileName("Drug Manufacturing License");
                              }}
                            >
                              VIEW
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <PdfView
          show={openPdf}
          handleClose={() => setOpenPdf(false)}
          pdfUrl={pdfFileUrl}
          filename={filename}
        />
      </div>
    </>
  );
};

export default SettingsAccount;
